var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartbilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.262,
    y1: -0.41,
    x2: 1.034,
    y2: 1.191,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#7d95e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#3f28dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SmartBilling",
    transform: "translate(-912 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6102",
    "data-name": "Rectangle 6102",
    width: 24,
    height: 24,
    transform: "translate(912 55)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Smart_Billing",
    "data-name": "Smart Billing",
    transform: "translate(914.763 57.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M20.3,2.835C19.87,2.4,19.436,1.881,19,1.36a.486.486,0,0,0-.781,0c-.347.347-.607.781-1.041,1.214-.347-.434-.694-.781-1.041-1.214q-.39-.52-.781,0c-.347.347-.607.781-1.041,1.214-.434-.52-.694-.867-1.041-1.214q-.39-.52-.781,0c-.347.347-.607.694-1.041,1.214-.347-.434-.694-.781-1.041-1.214a.486.486,0,0,0-.781,0c-.434.52-.867.954-1.3,1.475A1.649,1.649,0,0,0,7.9,3.962v10.5a1.955,1.955,0,0,0,1.821,2.082h9.194a1.955,1.955,0,0,0,1.821-2.082V3.962A1.649,1.649,0,0,0,20.3,2.835Z",
    transform: "translate(-2.262 -1.1)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3255",
    "data-name": "Group 3255",
    transform: "translate(8.413 4.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M14.743,11.314H11.967c-.52,0-.867-.173-.867-.607,0-.347.26-.607.781-.607h5.551c.52,0,.867.173.867.607s-.26.607-.867.607Z",
    transform: "translate(-11.1 -6.977)",
    fill: "#18253e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M14.743,7.714H11.881c-.52,0-.781-.26-.781-.607,0-.434.347-.607.781-.607h5.725c.434,0,.694.173.694.607a.615.615,0,0,1-.694.607Z",
    transform: "translate(-11.1 -6.5)",
    fill: "#18253e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M7.125,10.1v4.077c0,1.214.694,1.648,1.821,1.214,1.388-.52,2.862-1.128,4.25-1.648a1.4,1.4,0,0,1,1.908.607,1.348,1.348,0,0,1-.607,1.821c-.694.434-1.475.954-2.168,1.475h2.255c.781,0,.867.087.867.867v1.128a1.231,1.231,0,0,1-.694,1.214,1.051,1.051,0,0,1-1.3-.173c-.087,0-.087-.087-.173-.087-.781.954-1.561.954-2.255,0-1.041.607-1.561.434-2.168-.434H8.773c-2.082,1.388-4.51,1.388-6.852,1.3a.46.46,0,0,1-.52-.52v-7.2a1.1,1.1,0,0,1,.347-.607c1.128-.867,2.342-1.735,3.469-2.6A4.135,4.135,0,0,1,7.125,10.1Z",
    transform: "translate(-1.4 -2.294)",
    fill: "#33eeb1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartbilling);
export default __webpack_public_path__ + "static/media/smartbilling.7e0133d9b70fd643dfa4dd9378a739c6.svg";
export { ForwardRef as ReactComponent };